import { CanonicalContact, ContactRole } from './contactShape';

const normalizeSearchTerm = (term: string): string => {
  return term.trim().toLowerCase();
};

const contactMatchesTerm = (
  contact: CanonicalContact,
  term: string
): boolean => {
  if (contact.fullName.toLowerCase().includes(term)) {
    return true;
  }

  if (contact.companyName && contact.companyName.toLowerCase().includes(term)) {
    return true;
  }

  for (const service of contact.servicesProvided) {
    if (service.toLowerCase().includes(term)) {
      return true;
    }
  }

  return false;
};

export const filterBySearch = (
  contacts: CanonicalContact[],
  searchTerm: string
): CanonicalContact[] => {
  const term: string = normalizeSearchTerm(searchTerm);

  if (term.length === 0) {
    return contacts;
  }

  return contacts.filter((contact: CanonicalContact) =>
    contactMatchesTerm(contact, term)
  );
};

export const filterByRoles = (
  contacts: CanonicalContact[],
  allowedRoles: ContactRole[]
): CanonicalContact[] => {
  if (!allowedRoles || allowedRoles.length === 0) {
    return contacts;
  }

  const allowed = new Set<ContactRole>(allowedRoles);

  return contacts.filter((contact: CanonicalContact) =>
    allowed.has(contact.role)
  );
};

export const filterByCategories = (
  contacts: CanonicalContact[],
  allowedCategories: string[]
): CanonicalContact[] => {
  if (!allowedCategories || allowedCategories.length === 0) {
    return contacts;
  }

  const allowed = new Set<string>(allowedCategories);

  return contacts.filter((contact: CanonicalContact) =>
    contact.servicesProvided.some((service: string) => allowed.has(service))
  );
};

export const collectAvailableCategories = (
  contacts: CanonicalContact[]
): string[] => {
  const categories = new Set<string>();

  for (const contact of contacts) {
    for (const service of contact.servicesProvided) {
      categories.add(service);
    }
  }

  return Array.from(categories).sort();
};

export const collectAvailableRoles = (
  contacts: CanonicalContact[]
): ContactRole[] => {
  const roles = new Set<ContactRole>();

  for (const contact of contacts) {
    roles.add(contact.role);
  }

  return Array.from(roles);
};
